import React from "react";
import { Link } from "react-router-dom";
import logo from '../logo64.png';

const Navbar: React.FC = () => {
    return (
        <div className="container-fluid">
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light text-light border-bottom box-shadow mb-3">
                <img alt="Algorythms Software" src={logo} height="32" className="me-2" />
                <Link className="navbar-brand text-light" to="/">Algorythms</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
                    <div className="navbar-nav flex-grow-1">
                        <Link className="nav-link text-light" to="/">Home</Link>
                        <Link className="nav-link text-light" to="/resume">Resume</Link>
                        <Link className="nav-link text-light" to="/about">About</Link>
                        <Link className="nav-link text-light" to="/privacy">Privacy</Link>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
